import * as React from 'react';
import { observer, inject } from 'mobx-react';
import styled, { withTheme } from 'styled-components';
import { propStyles } from '@kurtosys/ksys-portal-components/build/utils/propStyles';
import Translate, { translate } from './Translate';
import Icon from './Icon';
import { FilterStore } from '../stores';

const ClearFiltersButton = styled<any, any>('button')`
    ${propStyles};
    cursor: pointer;
    outline: none;
`;

ClearFiltersButton.defaultProps = {
    display: "flex",
    alignItems: "center",
    fontFamily: "body",
    fontWeight: "normal",
    fontSize: "sm",
    color: "gray500",
    bgColor: "transparent",
    borderStyle: "none",
    selected: {
        color: "body"
    }
};

const ClearFiltersIcon = styled<any, any>(Icon)``;

ClearFiltersIcon.defaultProps = {
    height: "1.4em",
    width: "1.4em"
};

interface ClearFiltersProps {
    theme?: { [property: string]: string | number };
    translations?: { [property: string]: string };
    filterStore?: FilterStore;
}

export const ClearFilters: React.SFC<ClearFiltersProps> = ({ theme, translations, filterStore, ...props }) => (
    <ClearFiltersButton
        title={translate(translations, "Clear filters")}
        onClick={filterStore.filtersActive ? filterStore.clearFilters : () => undefined}
        data-selected={filterStore.filtersActive}
        {...theme.FiltersClearButton}
        {...props}
    >
        <Translate>Clear filters</Translate>
        <ClearFiltersIcon margin="0 0 0 0.25em" fileName="CloseIcon" />
    </ClearFiltersButton>
);

export default inject('translations', 'filterStore')(observer(withTheme(ClearFilters))) as any;


// WEBPACK FOOTER //
// ./src/Components/ClearFilters.tsx